const apiInstructions = (account, coreEventName) => {
  const re = `// 1. First identify user and record event

curl -X POST "https://us-central1-pmf-engine.cloudfunctions.net/eventRecord" \\
  -H "Content-Type: application/json" \\
  -d '{
    "data": {
      "userId": "abc",
      "accountId": "${account.id}",
      "eventName": "default",
    }
  }

  // Example response
  {"result":{"success":true}}
`

  const gc = `curl -X POST "https://us-central1-pmf-engine.cloudfunctions.net/userGetCommand" \\
  -H "Content-Type: application/json" \\
  -d '{
    "data": {
      "userId": "abc",
      "accountId": "${account.id}",
      "eventName": "default",
      "userAgent": "curl"
    }
  }

  // Example response when form is present
  {
    "success":true,
    "commands":[
      {
        "type": "form",
        "url": "https://pmf-engine.web.app/form/splint-invest/805f44cc-7fdf-425f-ba3b-eddae6046906/abc/",
        "formData": {"colors":{"brandLight":"rgba(34, 34, 34, 0.5)","background":"#ffffff","text":"#222222","brand":"#222222"}}
      }
    ],
    "functionVersion": "1.0.7"
  }
`

  return { re, gc }
}

export default apiInstructions
